
import { Component, Prop, Vue } from "vue-property-decorator";
import { TEmployeeSummary } from "@/models/employees";
import { SMApp } from "@/store";
import { EMPLOYEE_EMPLOYMENT_STATUS_LEAVER } from "@/constants/compliance";

const ICONS = {
  pencil: "pencil-sharp",
};

@Component({})
export default class EmployeeSummaryDetails extends Vue {
  @Prop({ type: Object, required: true }) readonly employeeSummary!: TEmployeeSummary;

  icons = ICONS;

  get isEmployeeTerminated() {
    return SMApp.employeeWorkingStatus === EMPLOYEE_EMPLOYMENT_STATUS_LEAVER;
  }

  get editable() {
    return this.employeeSummary.work_end_date && !this.isEmployeeTerminated;
  }

  edit() {
    if (!this.editable) return;

    if (!this.employeeSummary.work_end_date) return;

    this.$emit("open-popup");
  }
}
